import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function UseGetmails(mail_type, date) {
  const queryParams = getQueryParams(mail_type, date);
  return useQuery(['get-mails', mail_type, date], async () => {
    const response = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.GET_MAILS, queryParams)
    );
    return response.data;
  });
}
function getQueryParams(mail_type, date) {
  if (mail_type === 'saved') {
    return {
      is_saved: 'True',
      date: date,
    };
  } else if (mail_type === 'favorites') {
    return {
      is_favorite: 'True',
      date: date,
    };
  } else {
    return {
      mail_type: mail_type,
      date: date,
    };
  }
}
